import { auth } from '@/firebaseConfig';
import { API_ENDPOINTS } from '@/apiConfig';
import axiosClient from '@/axiosClient';

export function useReconcileComplaint() {
    const reconcileComplaint = async (complaint, reconcileData) => {
        try {
            // Prepare the data for the API
            const reconcileTicketData = {
                ticket_id: complaint.id,
                message: reconcileData.message,
                timestamp: new Date().toISOString(),
                mailer_status: false,
                user_id: auth.currentUser.uid,
                user_email: auth.currentUser.email
            };

            // Call the API endpoint to reconcile the ticket
            const response = await axiosClient.put(API_ENDPOINTS.reconcileTicket, reconcileTicketData);
            
            // Return the updated complaint from the API response
            return response.data;
            
        } catch (error) {
            console.error('Error reconciling complaint:', error);
            throw error;
        }
    };

    return {
        reconcileComplaint
    };
}
